import { ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.CarouselCompoundContainer = styled("div")(() => ({
    paddingLeft: 16,
    backgroundColor: 'transparent',
    borderRadius: 16,
    display: "inline-flex",
    alignItems: "center",
    height: 8,
}));

Styled.CarouselContainer = styled("div")(({ isActive }) => ({
    border: `1px solid ${isActive ? ColorSAP.primary[70] : ColorSAP.primary[40]}`,
    backgroundColor: isActive ? ColorSAP.primary[70] : "",
    borderRadius: "50%",
    width: 8,
    height: 8,
    marginRight: 16,
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: isActive ? ColorSAP.primary[70] : ColorSAP.primary[60],
        transition: isActive ? "none" : "background-color 0.2s ease",
    },
    cursor: "pointer",
}));

Styled.DialogCarouselContainer = styled("div")(({ isActive }) => ({
    border: `1px solid ${ColorSAP.neutral[0]}`,
    backgroundColor: isActive ? ColorSAP.neutral[0] : "",
    borderRadius: "50%",
    width: 12,
    height: 12,
    marginRight: 16,
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: ColorSAP.neutral[0],
        transition: isActive ? "none" : "background-color 0.2s ease",
    },
    cursor: "pointer",
}));

export default Styled;
